import { render } from "./OTPComponent.vue?vue&type=template&id=66dba57c"
import script from "./OTPComponent.vue?vue&type=script&lang=js"
export * from "./OTPComponent.vue?vue&type=script&lang=js"

import "./OTPComponent.vue?vue&type=style&index=0&id=66dba57c&lang=scss"

import exportComponent from "D:\\source\\Mobaxe.Docs.App\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/OTPComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "66dba57c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('66dba57c', __exports__)) {
    console.log('reload')
    api.reload('66dba57c', __exports__)
  }
  
  module.hot.accept("./OTPComponent.vue?vue&type=template&id=66dba57c", () => {
    console.log('re-render')
    api.rerender('66dba57c', render)
  })

}


export default __exports__